import { render } from "./CertificadoView.vue?vue&type=template&id=6e64fcfa"
import script from "./CertificadoView.vue?vue&type=script&lang=js"
export * from "./CertificadoView.vue?vue&type=script&lang=js"

import "./CertificadoView.vue?vue&type=style&index=0&id=6e64fcfa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__